export default {
  title: "Télécharger l'appli {{app}}",
  qr_code_desc: "Scannez ce QR code avec votre téléphone pour télécharger l'appli",
  cta: "Téléchargez l'appli et connectez-vous pour obtenir {{amount}} de cashback !",
  download_from: 'Ou télécharger depuis :',
  direct_link: 'Lien direct :',
};
